export default __webpack_public_path__ + "static/media/gallery-img10.75d8d171.jpeg";